import Activity from '@/api/activity'

const onError = (commit, error) => {
  commit('changeLoading', { isLoading: false })
  return Promise.reject(error)
}

export default {
  fetchPerPage: ({ commit }, filter) => {
    commit('changeLoading', { isLoading: true })
    return Activity.fetchAll(filter)
      .then(({ data, pagination }) => {
        commit('collectionForPageFetched', {
          collectionForPage: data,
          pagination,
          scope: filter
        })
        commit('changeLoading', { isLoading: false })
      })
      .catch(error => onError(commit, error))
  }
}



// WEBPACK FOOTER //
// ./src/store/skiliko/activities/actions.js